module.exports = __webpack_public_path__ + "static/media/accenture.a64cd357.webp";